import * as Yup from 'yup'
import {VALIDATION_KEYS} from "../utils/translation-constants"

export const CardLessSchema = () => {
    return Yup.object().shape({
      mobileNumber: Yup.string()
        .required(VALIDATION_KEYS.RECEIVER_MOBILE_NO)
        .min(9, VALIDATION_KEYS.VALID_MOBILE_NO)
        .max(10, VALIDATION_KEYS.VALID_MOBILE_NO),
      remarks: Yup.string()
      .required(VALIDATION_KEYS.REMARK)
      .min(4, VALIDATION_KEYS.REMARK_LENGTH),
      expiry: Yup.string().required(VALIDATION_KEYS.VALIDITY_REQUIRED),
      transferAmount: Yup.string()
        .required(VALIDATION_KEYS.AMOUNT_REQUIRED),
    })
  }
  